import { memo, useMemo } from "react";

import BadgeNext from "ds/components/BadgeNext";
import { ArrowsLeftRight } from "components/icons/generated";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";

import { RenderGroupRowCellProps } from ".";
import useCellFilterAction from "../useCellFilterAction";
import { ResourcesSuggestions } from "../../useIacManagementFilters/constants";
import IacManagementGroupCell from "../../components/Table/Row/Group/Cell";

const IacManagementTableGroupRowCellDrifted = memo((props: RenderGroupRowCellProps) => {
  const { row } = props;

  const driftedFilterAction = useCellFilterAction(
    ResourcesSuggestions.Drifted,
    (!!row.drifted).toString()
  );
  const actions = useMemo(() => [driftedFilterAction], [driftedFilterAction]);

  return (
    <IacManagementGroupCell {...props} actions={actions}>
      {(row.drifted && (
        <BadgeNext
          type="weak"
          variant="yellow"
          startIcon={ArrowsLeftRight}
          text={`${row.drifted}`}
        />
      )) || <TableCellEmpty />}
    </IacManagementGroupCell>
  );
});

IacManagementTableGroupRowCellDrifted.displayName = "IacManagementTableGroupRowCellDrifted";

export default IacManagementTableGroupRowCellDrifted;
